import apiClient from "../../axios/apiClient";


  export const getUserPermissionListByUserId =(token,id) =>
  async (dispatch) => {
    try {
      if(id==null)
      {
        return;
      }
      dispatch({ type: "GET_USER_PERMISSION_LISTBY_USER_ID_PENDING" });
      console.log(id)
      const response = await apiClient.get(
        `/api/v1/permissions`,
        {
          params: {
            userId: id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_USER_PERMISSION_LISTBY_USER_ID_FULFILLED",
        payload: response.data?.data,
        usertypeCount: response.data?.count,
      });
    } catch (error) {
      dispatch({
        type: "GET_USER_PERMISSION_LISTBY_USER_ID_REJECTED",
        payload: error.response,
      });
    }
  };

export const updateUserPermissionData = (token, id, permissions) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_USER_PERMISSION__PENDING" });
    const data= permissions;
    const response = await apiClient.put(
      `/api/v1/permissions/${id}`, // Endpoint URL with City ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_USER_PERMISSION__FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_USER_PERMISSION__REJECTED", payload: error.response });
  }
};
